import React, { useState, useEffect } from 'react';
import { Activity, Clock, RefreshCw, Footprints, LogIn, Search} from 'lucide-react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const AdminLogs = () => {
    const [logsAcesso, setLogsAcesso] = useState([]);
    const [loading, setLoading] = useState(true);

    // FILTROS
    const [filtroPerfil, setFiltroPerfil] = useState('Todos');
    const [filtroDias,   setFiltroDias]   = useState(15);
    const [filtroNome,   setFiltroNome]   = useState('');
    const [filtroAcao,   setFiltroAcao]   = useState('Todos');

    const fetchData = async () => {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        const headers = { 'Authorization': `Bearer ${token}` };
        try {
            const res = await fetch('/api/logs/acessos', { headers });
            if (res.ok) setLogsAcesso(await res.json());
        } catch (error) {
            console.error("Erro ao carregar logs", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const themePurple = '#8b5cf6'; 
    const bgPurpleLight = '#f5f3ff';


    const [chartData, setChartData] = useState([]);

    // FUNÇÃO ATUALIZADA: Agora envia perfil e dias para a API
    const fetchChartData = async (perfilSelecionado, diasSelecionados) => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`/api/logs/stats-acessos?perfil=${perfilSelecionado}&dias=${diasSelecionados}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) setChartData(await res.json());
        } catch (e) { console.error(e); }
    };

    // EFEITO ATUALIZADO: Monitora mudanças em perfil e dias
    useEffect(() => {
        fetchChartData(filtroPerfil, filtroDias);
    }, [filtroPerfil, filtroDias]);

    // Função utilitária para verificar se uma data está dentro do período selecionado
    const isDateWithinRange = (dateString, days) => {
        if (!dateString) return false;
        const targetDate = new Date(dateString);
        const cutoffDate = new Date();
        cutoffDate.setDate(cutoffDate.getDate() - parseInt(days, 10));
        return targetDate >= cutoffDate;
    };

    return (
        <div>
            {/* CABEÇALHO DO MÓDULO */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ padding: '12px', backgroundColor: bgPurpleLight, borderRadius: '12px', color: themePurple }}>
                        <Activity size={28} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: '0 0 4px 0' }}>Monitoramento de Atividades</h2>
                        <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>Visão geral do uso do sistema e histórico de auditoria.</p>
                    </div>
                </div>

                <button 
                    onClick={fetchData} 
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                >
                    <RefreshCw size={16} className={loading ? "animate-spin" : ""} color={themePurple} /> 
                    Atualizar Dados
                </button>
            </div>
            
            {/* GRÁFICO DE ACESSOS RECENTES */}
            <div style={{ 
                backgroundColor: '#fff', 
                padding: '24px', 
                borderRadius: '16px', 
                border: '1px solid #e2e8f0', 
                marginBottom: '32px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
            }}>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#0f172a', margin: 0 }}>
                        Frequência de Acessos - Usuários Únicos
                    </h3>
                    
                    <div style={{ display: 'flex', gap: '12px' }}>
                        {/* FILTRO DE DATA */}
                        <select 
                            value={filtroDias} 
                            onChange={(e) => setFiltroDias(e.target.value)}
                            style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', color: '#475569', outline: 'none', cursor: 'pointer' }}
                        >
                            <option value={5}>Últimos 5 Dias</option>
                            <option value={15}>Últimos 15 Dias</option>
                            <option value={30}>Últimos 30 Dias</option>
                            <option value={45}>Últimos 45 Dias</option>
                        </select>

                        <select 
                            value={filtroPerfil} 
                            onChange={(e) => setFiltroPerfil(e.target.value)}
                            style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', color: '#475569', outline: 'none', cursor: 'pointer' }}
                        >
                            <option value="Todos">Todos os Perfis</option>
                            <option value="Admin">Admin</option>
                            <option value="Gerente">Gerente</option>
                            <option value="Treinamento">Treinamento</option>
                            <option value="Operacional">Operacional</option>
                            <option value="Medico">Médico</option>
                            <option value="EntrevistaDesligamento">Entrevista Desligamento</option>
                            <option value="Contabil">Contábil</option>
                            <option value="Gerente Adm">Gerente Adm</option>
                            <option value="Fiscal">Fiscal</option>
                            <option value="Financeiro">Financeiro</option>
                            <option value="ProcessoSeletivo">Processo Seletivo</option>
                            <option value="Diretoria">Diretoria</option>
                            <option value="RH">RH</option>                  
                        </select>
                    </div>
                </div>

                <div style={{ width: '100%', height: 250 }}>
                    <ResponsiveContainer>
                        <AreaChart data={chartData}>
                            <defs>
                                <linearGradient id="colorAcessos" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor={themePurple} stopOpacity={0.3}/>
                                    <stop offset="95%" stopColor={themePurple} stopOpacity={0}/>
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                            <XAxis 
                                dataKey="label" 
                                axisLine={false} 
                                tickLine={false} 
                                tick={{fill: '#64748b', fontSize: 12}}
                                dy={10}
                            />
                            <YAxis 
                                axisLine={false} 
                                tickLine={false} 
                                tick={{fill: '#64748b', fontSize: 12}}
                            />
                            <Tooltip 
                                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }}
                            />
                            <Area 
                                type="monotone" 
                                dataKey="acessos" 
                                stroke={themePurple} 
                                strokeWidth={3}
                                fillOpacity={1} 
                                fill="url(#colorAcessos)" 
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            </div>
            

            {/* TÍTULO + FILTROS DA TABELA */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '8px' }}>
                    <Footprints size={18} color={themePurple} />
                    <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>Trilha de Acessos</h3>
                </div>

                {/* Busca por nome */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '6px 12px' }}>
                    <Search size={14} color="#94a3b8" />
                    <input
                        type="text"
                        placeholder="Buscar usuário..."
                        value={filtroNome}
                        onChange={e => setFiltroNome(e.target.value)}
                        style={{ border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '13px', color: '#334155', width: '160px' }}
                    />
                </div>

                {/* Filtro de ação */}
                <select value={filtroAcao} onChange={e => setFiltroAcao(e.target.value)}
                    style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', color: '#475569', outline: 'none', cursor: 'pointer', backgroundColor: '#f8fafc' }}>
                    <option value="Todos">Todas as ações</option>
                    <option value="LOGIN">Login</option>
                    <option value="NAVEGACAO">Navegação</option>
                </select>

                {/* Filtro de perfil */}
                <select value={filtroPerfil} onChange={e => setFiltroPerfil(e.target.value)}
                    style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', color: '#475569', outline: 'none', cursor: 'pointer', backgroundColor: '#f8fafc' }}>
                    <option value="Todos">Todos os perfis</option>
                    <option value="Admin">Admin</option>
                    <option value="Gerente">Gerente</option>
                    <option value="RH">RH</option>
                    <option value="Contabil">Contábil</option>
                    <option value="Fiscal">Fiscal</option>
                    <option value="Financeiro">Financeiro</option>
                    <option value="Diretoria">Diretoria</option>
                    <option value="Treinamento">Treinamento</option>
                    <option value="Operacional">Operacional</option>
                    <option value="Medico">Médico</option>
                    <option value="ProcessoSeletivo">Processo Seletivo</option>
                    <option value="Gerente Adm">Gerente Adm</option>
                </select>

                {/* Filtro de período */}
                <select value={filtroDias} onChange={e => setFiltroDias(e.target.value)}
                    style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', color: '#475569', outline: 'none', cursor: 'pointer', backgroundColor: '#f8fafc' }}>
                    <option value={5}>Últimos 5 dias</option>
                    <option value={15}>Últimos 15 dias</option>
                    <option value={30}>Últimos 30 dias</option>
                    <option value={45}>Últimos 45 dias</option>
                </select>

                {/* Limpar filtros */}
                {(filtroNome || filtroAcao !== 'Todos' || filtroPerfil !== 'Todos') && (
                    <button onClick={() => { setFiltroNome(''); setFiltroAcao('Todos'); setFiltroPerfil('Todos'); }}
                        style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #fecdd3', backgroundColor: '#fff1f2', color: '#e11d48', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                        Limpar
                    </button>
                )}
            </div>

            {/* TABELA DE ACESSOS */}
            <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto', maxHeight: '600px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', tableLayout: 'fixed' }}>
                        <colgroup>
                            <col style={{ width: '110px' }} /> {/* Ação */}
                            <col style={{ width: '220px' }} /> {/* Usuário */}
                            <col />                            {/* Detalhe — ocupa o resto */}
                            <col style={{ width: '160px' }} /> {/* Data/Hora */}
                        </colgroup>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                            <tr style={{ backgroundColor: '#f8fafc', color: '#64748b', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                <th style={{ padding: '14px 16px', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Ação</th>
                                <th style={{ padding: '14px 16px', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Usuário</th>
                                <th style={{ padding: '14px 16px', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Detalhe</th>
                                <th style={{ padding: '14px 16px', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Data / Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="4" style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>Carregando...</td></tr>
                            ) : (
                                logsAcesso
                                    .filter(log => {
                                        const ehRecente  = isDateWithinRange(log.DATA_REGISTRO, filtroDias);
                                        const usuariosIgnorados = ['Admin', 'JULIA CRISTINA DE AZEVEDO INDAMI', 'FERNANDA PINHEIRO RODRIGUES', 'RODRIGO FORECHI RIBEIRO'];
                                        const naoEhAdmin = !usuariosIgnorados.includes(log.USUARIO_NOME);
                                        const matchPerfil = filtroPerfil === 'Todos' || log.PERFIL === filtroPerfil;
                                        const matchAcao  = filtroAcao   === 'Todos' || log.ACAO === filtroAcao;
                                        const matchNome  = !filtroNome  || (log.USUARIO_NOME || '').toLowerCase().includes(filtroNome.toLowerCase());
                                        return ehRecente && naoEhAdmin && matchPerfil && matchAcao && matchNome;
                                    })
                                    .map((log) => (
                                        <tr key={log.ID} style={{ borderBottom: '1px solid #f1f5f9' }}
                                            onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
                                            onMouseOut={e  => e.currentTarget.style.backgroundColor = 'transparent'}>
                                            <td style={{ padding: '12px 16px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '700', fontSize: '13px', color: log.ACAO === 'LOGIN' ? '#10b981' : '#3b82f6' }}>
                                                    {log.ACAO === 'LOGIN' ? <LogIn size={14} /> : <Footprints size={14} />}
                                                    {log.ACAO}
                                                </div>
                                            </td>
                                            <td style={{ padding: '12px 16px' }}>
                                                <div style={{ fontWeight: '600', fontSize: '13px', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {log.USUARIO_NOME}
                                                </div>
                                                {log.PERFIL && <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{log.PERFIL}</div>}
                                            </td>
                                            <td style={{ padding: '12px 16px', fontSize: '13px', color: '#475569', wordBreak: 'break-word' }}>
                                                {log.DETALHE}
                                            </td>
                                            <td style={{ padding: '12px 16px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#64748b', whiteSpace: 'nowrap' }}>
                                                    <Clock size={13} />
                                                    {new Date(log.DATA_REGISTRO).toLocaleString('pt-BR')}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminLogs;